export var AuthorizationStatusEnum;
(function (AuthorizationStatusEnum) {
    AuthorizationStatusEnum["AuthorizationStatusAlways"] = "Always";
    AuthorizationStatusEnum["AuthorizationStatusDenied"] = "Denied";
    AuthorizationStatusEnum["AuthorizationStatusNotDetermined"] = "Not Determined";
    AuthorizationStatusEnum["AuthorizationStatusRestricted"] = "Restricted";
    AuthorizationStatusEnum["AuthorizationStatusUnknown"] = "Unknown";
    AuthorizationStatusEnum["AuthorizationStatusWhenInUse"] = "When In Use";
})(AuthorizationStatusEnum || (AuthorizationStatusEnum = {}));
export var AccuracyAuthorizationEnum;
(function (AccuracyAuthorizationEnum) {
    AccuracyAuthorizationEnum["AccuracyAuthorizationFull"] = "FullAccuracy";
    AccuracyAuthorizationEnum["AccuracyAuthorizationReduced"] = "ReducedAccuracy";
    AccuracyAuthorizationEnum["AccuracyAuthorizationUnknown"] = "UnknownAccuracy";
})(AccuracyAuthorizationEnum || (AccuracyAuthorizationEnum = {}));
